import { observable, action, computed } from "mobx";
import {post} from "../services/ajax.service";

class CfoSummaryStore {
    @observable participant_count = 0;
    @observable total_spend = 0;
    @observable average_claim_cost = 0;
    @observable pmpm = 0;
    @observable count = 0;
    @observable total_claims = 0;
    @observable summary_table = [];
    @observable summarybycategorydrugs = [];
    @observable summarybycategorydrugscount = 0;
    @observable url ="/api/v1/cfosummaryactions";
    @observable specialty_type ="";
    @observable all_specialty = {}

    @action setSpecialtyType = (value) => {
      this.specialty_type=value
    }

    @computed get summed_up_cost () {
        if(this.summary_table.length > 0){
            let sum = 0
            for(let i of this.summary_table) {
                sum = sum + parseFloat(i.INGREDIENT_COST)
            }
            return sum;
        }

        return 0;
    }

    @computed get summed_up_cost_drugs () {
      if(this.summarybycategorydrugs.length > 0){
          let sum = 0
          for(let i of this.summarybycategorydrugs) {
              sum = sum + parseFloat(i.claim_cost)
          }
          return sum;
      }

      return 0;
  }
  @computed get tiles() {
    return parseInt(this.count / 100) > 0 ? parseInt(this.count / 100) + 1 : 0;
  }

    @action getTotalSpend = async (data) => {
        this.total_spend = 0
        try {
            let response = await post(
              `${this.url}/getTotalSpend`,
              data
            );

            this.total_spend =  response.data[0].TOTAL_SPEND;
          } catch (err) {
            console.log(err);
          }

    }
    @action getAverageClaimCost = async (data) => {
        this.average_claim_cost = 0
        try {
            let response = await post(
              `${this.url}/getAverageClaimCost`,
              data
            );

            this.average_claim_cost =  response.data[0].avg_cost;
          } catch (err) {
            console.log(err);
          }

    }
    @action getTotalClaims = async (data) => {
        this.total_claims = 0
        try {
            let response = await post(
              `${this.url}/getTotalClaims`,
              data
            );

            this.total_claims =  response.data[0].TOTAL_CLAIMS;
          } catch (err) {
            console.log(err);
          }

    }
    @action getTotalParticipants = async (data) => {
        this.participant_count = 0
        try {
            let response = await post(
              `${this.url}/getTotalParticipants`,
              data
            );

            this.participant_count =  response.data[0].TOTAL_PARTICIPANTS;
          } catch (err) {
            console.log(err);
          }

    }
    @action getPMPM = async (data) => {
        this.pmpm = 0
        try {
            let response = await post(
              `${this.url}/getPMPM`,
              data
            );

            this.pmpm =  response.data[0].PMPM;
          } catch (err) {
            console.log(err);
          }

    }


    @action getSummaryTable = async (data) => {
        this.summary_table = []
        try {
            let response = await post(
              `${this.url}/getSummaryTable`,
              data
            );
            let specialty_data = {TOTAL_CLAIMS:0,claim_cost:0,AWP:0,category:'S'}
            response.data.forEach(d => {
              if(d.filtered_category == "SB" || d.filtered_category == "SG") {
                specialty_data['TOTAL_CLAIMS'] +=Number(d["TOTAL_CLAIMS"])
                specialty_data['claim_cost'] +=Number(d["claim_cost"])
                specialty_data['AWP'] +=Number(d["AWP"])
                specialty_data["category"] = "S"
                specialty_data["CATEGORY_NAME"] = "Specialty"

              }
            })
            this.all_specialty = specialty_data
            this.summary_table =  response.data;
          } catch (err) {
            console.log(err);
          }

    }


    @action getDrugSummaryByCategory = async (data) => {
      this.summarybycategorydrugs = []
      try {
          let response = await post(
            `${this.url}/getDrugSummaryByCategory`,
            data
          );

          this.summarybycategorydrugs =  response.data;
        } catch (err) {
          console.log(err);
        }

  }
    @action getDrugSummaryByCategoryCount = async (data) => {
      this.count = 0;
      try {
          let response = await post(
            `${this.url}/getDrugSummaryByCategoryCount`,
            data
          );

          this.count =  response.data[0].total_data;
        } catch (err) {
          console.log(err);
        }

  }

}

export default CfoSummaryStore;
